<template>
  <div
    class="txn-div px-1 py-2 mx-1 my-2 border rounded"
    style="border: 2px solid black"
  >
    <strong :class="txn.amount < 0 ? 'text-danger' : 'text-success'">{{
      formatCurrencyDollarSign(txn.amount)
    }}</strong>
    {{ txn.orig_trsxn_desc }}
  </div>
</template>
<script>
import numberFormatMixin from "@/mixins/numberFormatMixin";

export default {
  name: "ListItemView",
  props: {
    txn: {
      type: Object,
      required: true,
    },
  },
  mixins: [numberFormatMixin],
};
</script>
